import { createAction } from '@reduxjs/toolkit'

export const setTransactionHistoryData: any = createAction('transactions/setTransactionHistoryData')
